<template>
  <page>
    <div v-if="entry">
      <page-title>{{ entry.title }}</page-title>

      <div class="mailing">
        <p class="mailing__intro">{{ introText }}</p>
        <div v-html="htmlContent" />
      </div>
    </div>

    <div v-else>
      <div>Noch keine Newsletter vorhanden</div>
    </div>
  </page>
</template>

<script>
import PageMixin from '@/mixins/pages/Page'

export default {
  name: 'Mailing',
  mixins: [PageMixin],
  props: {
    entry: {
      type: [Object],
      default: () => null
    }
  },
  computed: {
    introText () {
      return this.entry.vuexState['intro_text']
    },
    htmlContent () {
      return this.entry.htmlContent.replace(/style="[^"]*"/g, '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mailings/Mailing.vue